<div *ngIf="!isEditMode; else editMode" class="row">
  <label class="col-9">{{ initialValue || ' - ' }}</label>
  <div class="pointer col-1 icon-container" (click)="isEditMode = true">
    <i class="ifc-custom ifc-pencil" aria-hidden="true"></i>
  </div>
</div>

<ng-template #editMode>
  <div class="row">
    <input type="text" [value]="initialValue" #input class="col-8" />
    <div
      class="pointer col-1 icon-container"
      (click)="saveChanges(input.value)"
    >
      <i class="ifc-custom ifc-check" aria-hidden="true"></i>
    </div>
    <div class="pointer col-1 icon-container" (click)="cancelEditing()">
      <i class="ifc-custom ifc-close" aria-hidden="true"></i>
    </div>
  </div>
</ng-template>
